export default __webpack_public_path__ + "static/media/Chrome.56af9a41.svg";